import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import { Logo } from '../../static/images';
import tokens from '../theme/tokens';

// 관리자 틀 — 왼쪽 메뉴(넓은 화면) / 위쪽 가로 탭(좁은 화면) + 본문. 메뉴는 AdminPage 가 넘긴다
export const ADMIN_MENUS = [
  { key: 'summary', label: '대시보드' },
  { key: 'notice', label: '공지 · 상단 배너' },
  { key: 'banners', label: '이미지 배너' },
  { key: 'fares', label: '운임 관리' },
  { key: 'members', label: '회원 관리' },
  { key: 'orders', label: '접수 내역' },
];

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#fbf8f6',
    fontFamily: tokens.font,
    [theme.breakpoints.down('sm')]: { flexDirection: 'column' },
  },
  side: {
    flex: 'none',
    width: 224,
    padding: '22px 14px',
    backgroundColor: tokens.surface,
    borderRight: `1px solid ${tokens.lineSoft}`,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '12px 14px',
      borderRight: 'none',
      borderBottom: `1px solid ${tokens.lineSoft}`,
    },
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px 18px',
    '& img': { width: 72, height: 'auto' },
    '& b': { marginLeft: 10, fontSize: 14, color: tokens.text, letterSpacing: -0.6 },
    [theme.breakpoints.down('sm')]: { padding: '0 0 10px' },
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      overflowX: 'auto',
      paddingBottom: 2,
    },
  },
  item: {
    justifyContent: 'flex-start',
    height: 42,
    padding: '0 12px',
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: -0.6,
    color: tokens.text,
    whiteSpace: 'nowrap',
    transition: 'background-color .12s, color .12s',
    '&:hover': { backgroundColor: tokens.primarySoft, color: tokens.primaryDark },
    [theme.breakpoints.down('sm')]: { height: 36, padding: '0 12px', fontSize: 13 },
  },
  on: { backgroundColor: tokens.primarySoft, color: tokens.primaryDark },
  sideFoot: {
    marginTop: 'auto',
    paddingTop: 16,
    borderTop: `1px solid ${tokens.lineSoft}`,
    [theme.breakpoints.down('sm')]: { display: 'none' },
  },
  who: {
    padding: '0 8px 10px',
    fontSize: 13,
    color: tokens.muted,
    letterSpacing: -0.4,
    '& b': { display: 'block', color: tokens.ink, fontSize: 14 },
  },
  main: {
    flex: '1 1 auto',
    minWidth: 0,
    padding: '28px 32px 60px',
    [theme.breakpoints.down('sm')]: { padding: '18px 14px 60px' },
  },
  inner: { maxWidth: 1080 },
  head: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
    '& h2': { margin: 0, fontSize: 24, fontWeight: 700, letterSpacing: -1, color: tokens.ink },
    [theme.breakpoints.down('sm')]: { '& h2': { fontSize: 20 } },
  },
  link: {
    height: 36,
    padding: '0 14px',
    borderRadius: 18,
    border: `1px solid ${tokens.line}`,
    fontSize: 13,
    fontWeight: 700,
    color: tokens.text,
    '&:hover': { borderColor: tokens.primary, color: tokens.primaryDark },
  },
}));

function AdminShell({ active, onSelect, user, onExit, onLogout, children }) {
  const cs = useStyles();
  const current = ADMIN_MENUS.find((m) => m.key === active) || ADMIN_MENUS[0];
  return (
    <div className={cs.root}>
      <aside className={cs.side}>
        <div className={cs.brand}><img src={Logo} alt="퀴노스" /><b>관리자</b></div>
        <nav className={cs.nav}>
          {ADMIN_MENUS.map((m) => (
            <ButtonBase key={m.key} className={clsx(cs.item, m.key === active && cs.on)} onClick={() => onSelect(m.key)} focusRipple={false}>{m.label}</ButtonBase>
          ))}
        </nav>
        <div className={cs.sideFoot}>
          <div className={cs.who}>로그인<b>{(user && (user.name || user.email)) || '관리자'}</b></div>
          <ButtonBase className={clsx(cs.item)} onClick={onExit} focusRipple={false}>사이트로 이동</ButtonBase>
          <ButtonBase className={clsx(cs.item)} onClick={onLogout} focusRipple={false}>로그아웃</ButtonBase>
        </div>
      </aside>
      <main className={cs.main}>
        <div className={cs.inner}>
          <div className={cs.head}>
            <h2>{current.label}</h2>
            <ButtonBase className={cs.link} onClick={onExit} focusRipple={false}>사이트 보기</ButtonBase>
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}

export default AdminShell;
